type ForgeRoutingPayload = {
  schema_version: 'forge_failure.v1' | 'forge_guidance.v1';
  customer_safe_summary: string;
  next_supported_operation: string;
  refresh_required: boolean;
};

type ErrorWithResponse = {
  response?: { data?: unknown };
};

function readRoutingPayload(value: unknown, key: 'forge_failure' | 'forge_guidance') {
  if (!value || typeof value !== 'object') return null;
  const candidate = (value as Record<string, unknown>)[key];
  if (!candidate || typeof candidate !== 'object') return null;
  const routing = candidate as Partial<ForgeRoutingPayload>;
  const expectedSchema = key === 'forge_failure' ? 'forge_failure.v1' : 'forge_guidance.v1';
  if (
    routing.schema_version !== expectedSchema ||
    typeof routing.customer_safe_summary !== 'string' ||
    !routing.customer_safe_summary ||
    typeof routing.next_supported_operation !== 'string' ||
    !routing.next_supported_operation ||
    typeof routing.refresh_required !== 'boolean'
  )
    return null;
  return routing as ForgeRoutingPayload;
}

function formatRouting(routing: ForgeRoutingPayload) {
  return `${routing.customer_safe_summary}${
    routing.refresh_required ? ' Refresh the current Forge context first.' : ''
  } Next supported action: ${routing.next_supported_operation}.`;
}

/** Return server-authored Forge routing without changing unmapped API errors. */
export function getForgeFailureMessage(error: unknown) {
  const payload = (error as ErrorWithResponse | undefined)?.response?.data;
  const routing = readRoutingPayload(payload, 'forge_failure');
  return routing ? formatRouting(routing) : null;
}

/** Return server-authored guidance from an otherwise successful preview. */
export function getForgeGuidanceMessage(payload: unknown) {
  const routing = readRoutingPayload(payload, 'forge_guidance');
  return routing ? formatRouting(routing) : null;
}
